/**
 * Persist join intent across auth so users never land on Home after invite.
 */

const PENDING_KEY = "tra_pending_arena_invitation_v1";

/**
 * @param {{
 *   invitationId?: string | null;
 *   arenaId?: string | null;
 *   targetRoute?: string | null;
 * }} payload
 */
export function writePendingArenaInvitation(payload) {
  const invitationId = String(payload?.invitationId || "").trim();
  const arenaId = String(payload?.arenaId || "").trim();
  const targetRoute = String(payload?.targetRoute || "").trim();
  if (!invitationId && !arenaId && !targetRoute) {
    clearPendingArenaInvitation();
    return null;
  }
  const record = {
    invitationId: invitationId || null,
    arenaId: arenaId || null,
    targetRoute:
      targetRoute ||
      (invitationId ? `/join/${encodeURIComponent(invitationId)}` : null),
    savedAtMs: Date.now(),
  };
  try {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify(record));
  } catch {
    /* private mode */
  }
  return record;
}

export function readPendingArenaInvitation() {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return {
      invitationId: parsed.invitationId || null,
      arenaId: parsed.arenaId || null,
      targetRoute: parsed.targetRoute || null,
      savedAtMs: Number(parsed.savedAtMs) || null,
    };
  } catch {
    return null;
  }
}

export function clearPendingArenaInvitation() {
  try {
    sessionStorage.removeItem(PENDING_KEY);
  } catch {
    /* private mode */
  }
}

export function hasPendingArenaInvitation() {
  const p = readPendingArenaInvitation();
  return Boolean(p?.invitationId || p?.targetRoute);
}
